import './base/index';
import './_partials/slick-slider';
import showCrisp from './dashboard/show-crisp';

showCrisp();
